import React from "react";
import HomeIntro from "./HomeIntro";
import LandscapeWhoWeAre from "./LandscapeWhoWeAre";
import CenteredPortraitWoWeAre from "./CenteredPortraitWoWeAre";
import ClassicWhoWeAre from "./ClassicWhoWeAre";
import { useSelector } from "react-redux";

function HospitalWhoWeAreWrapper({hostpitalAbout}) {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_about === "centered-portrait" ? (
        <CenteredPortraitWoWeAre hostpitalAbout={hostpitalAbout} />
      ) : sitedata?.theme_about === "classic-about" ? (
        <ClassicWhoWeAre hostpitalAbout={hostpitalAbout} />
      ) : sitedata?.theme_about === "wide-landscape" ? (
        <LandscapeWhoWeAre hostpitalAbout={hostpitalAbout} />
      ) : (
        <HomeIntro hostpitalAbout={hostpitalAbout} />
      )}

    </>
  );
}

export default HospitalWhoWeAreWrapper;
